module.exports = __webpack_public_path__ + "resources/chats-a324dd1d3c5ffc7944b4f4df6e99f100.svg";